import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useForm } from 'react-hook-form'
import { Button } from '@mui/material'
import ContentHeader from '@src/components/ContentHeader'
import { MemberDetail } from '@src/manager/models/userDashboard'
import {
  managerPath,
  RouteSection,
  toManagerRoute,
} from '@src/common/appConfig'
import commonMessages from '@common/messages'
import messages from '@manager/utils/messages'
import { ReactComponent as IconSave } from '@src/assets/icons/iconSave.svg'
import MemberForm from './components/MemberForm'
import { BREADCRUMBS } from './utils'
import { useDispatch } from 'react-redux'
import Snackbar, { SnackbarState } from '@src/components/Snackbar'
import { useGlobalSnackbar, useLoading } from '@src/hooks'
import {
  createMemberAction,
  MemberActionType,
} from '@src/manager/reducers/member/memberActions'

export default function MemberCreate() {
  const { formatMessage: f } = useIntl()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()
  const { control, handleSubmit } = useForm<MemberDetail>({
    defaultValues: {},
  })
  const { status, setSnackbar, clearSnackbar } = useGlobalSnackbar({
    page: RouteSection.UserDashboard,
  })
  const { openSpinner } = useLoading({
    endActions: {
      success: [MemberActionType.CREATE_MEMBER_SUCCESS],
      error: [MemberActionType.CREATE_MEMBER_ERROR],
    },
    cbk: {
      success: () => {
        setSnackbar({
          state: SnackbarState.Success,
          message: f(commonMessages.createSuccess),
          notKeepData: false,
        })
        document.documentElement.scrollTop = 0
        navigate(
          generatePath(toManagerRoute(managerPath.userDashboard.dashboard), {
            id,
          })
        )
      },
      error: () => {
        setSnackbar({
          state: SnackbarState.Error,
          message: f(commonMessages.createFailed),
          notKeepData: true,
        })
        document.documentElement.scrollTop = 0
      },
    },
  })

  const onSubmit = (data: MemberDetail) => {
    openSpinner()
    dispatch(createMemberAction({ id: id!, data }))
  }

  return (
    <>
      {status && (
        <Snackbar
          severity={SnackbarState.Error}
          message={status.message!}
          onClose={clearSnackbar}
        />
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <ContentHeader
          title={f(messages.memberCreate)}
          breadcrumbs={[
            ...BREADCRUMBS,
            {
              title: messages.userDashboard,
              route: generatePath(
                toManagerRoute(managerPath.userDashboard.dashboard),
                { id: id }
              ),
            },
            {
              title: messages.memberCreate,
            },
          ]}
          buttonList={[
            <Button variant="contained" type="submit" startIcon={<IconSave />}>
              {f(commonMessages.save)}
            </Button>,
          ]}
        />
        <MemberForm control={control} />
      </form>
    </>
  )
}
